/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CoreRouteImport } from './routes/core'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as LegalwarePowerUserRouteImport } from './routes/legalware-power-user'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as CoreIndexRouteImport } from './routes/core/index'
import { Route as CoreAutomationsRouteImport } from './routes/core/automations'
import { Route as CoreLeadDocketRouteImport } from './routes/core/lead-docket'
import { Route as CoreOrganizationManagerRouteImport } from './routes/core/organization-manager'
import { Route as CoreSettingsRouteImport } from './routes/core/settings'
import { Route as CoreAnalyticsIndexRouteImport } from './routes/core/analytics/index'
import { Route as CoreAnalyticsAiUsageRouteImport } from './routes/core/analytics/ai-usage'
import { Route as CoreAnalyticsCalendarRouteImport } from './routes/core/analytics/calendar'
import { Route as CoreAnalyticsDeadlinesAndEventsRouteImport } from './routes/core/analytics/deadlines-and-events'
import { Route as CoreAnalyticsInvoiceRouteImport } from './routes/core/analytics/invoice'
import { Route as CoreAnalyticsLoisUsageRouteImport } from './routes/core/analytics/lois-usage'
import { Route as CoreAnalyticsProjectDataRouteImport } from './routes/core/analytics/project-data'
import { Route as CoreAnalyticsTasksRouteImport } from './routes/core/analytics/tasks'
import { Route as CoreAnalyticsTimeEntryRouteImport } from './routes/core/analytics/time-entry'
import { Route as CoreAnalyticsUserAuditRouteImport } from './routes/core/analytics/user-audit'
import { Route as CoreBoardBoardIdRouteImport } from './routes/core/board/$boardId'
import { Route as CoreKanbanIndexRouteImport } from './routes/core/kanban/index'
import { Route as CoreKanbanProjectIdRouteImport } from './routes/core/kanban/$projectId'
import { Route as CoreLeadDocketIndexRouteImport } from './routes/core/lead-docket/index'
import { Route as CoreLeadDocketAnalyticsRouteImport } from './routes/core/lead-docket/analytics'
import { Route as CoreLeadDocketAutomationsRouteImport } from './routes/core/lead-docket/automations'
import { Route as CoreLeadDocketKanbanRouteImport } from './routes/core/lead-docket/kanban'
import { Route as CoreSupportRequestsIndexRouteImport } from './routes/core/support-requests/index'
import { Route as CoreSupportRequestsCreateRouteImport } from './routes/core/support-requests/create'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
})
const CoreRoute = CoreRouteImport.update({
  id: '/core',
  path: '/core',
  getParentRoute: () => rootRouteImport,
})
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
})
const LegalwarePowerUserRoute = LegalwarePowerUserRouteImport.update({
  id: '/legalware-power-user',
  path: '/legalware-power-user',
  getParentRoute: () => rootRouteImport,
})
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
})
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
})
const CoreIndexRoute = CoreIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CoreRoute,
})
const CoreAutomationsRoute = CoreAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => CoreRoute,
})
const CoreLeadDocketRoute = CoreLeadDocketRouteImport.update({
  id: '/lead-docket',
  path: '/lead-docket',
  getParentRoute: () => CoreRoute,
})
const CoreOrganizationManagerRoute = CoreOrganizationManagerRouteImport.update({
  id: '/organization-manager',
  path: '/organization-manager',
  getParentRoute: () => CoreRoute,
})
const CoreSettingsRoute = CoreSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => CoreRoute,
})
const CoreAnalyticsIndexRoute = CoreAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => CoreRoute,
})
const CoreAnalyticsAiUsageRoute = CoreAnalyticsAiUsageRouteImport.update({
  id: '/analytics/ai-usage',
  path: '/analytics/ai-usage',
  getParentRoute: () => CoreRoute,
})
const CoreAnalyticsCalendarRoute = CoreAnalyticsCalendarRouteImport.update({
  id: '/analytics/calendar',
  path: '/analytics/calendar',
  getParentRoute: () => CoreRoute,
})
const CoreAnalyticsDeadlinesAndEventsRoute =
  CoreAnalyticsDeadlinesAndEventsRouteImport.update({
    id: '/analytics/deadlines-and-events',
    path: '/analytics/deadlines-and-events',
    getParentRoute: () => CoreRoute,
  })
const CoreAnalyticsInvoiceRoute = CoreAnalyticsInvoiceRouteImport.update({
  id: '/analytics/invoice',
  path: '/analytics/invoice',
  getParentRoute: () => CoreRoute,
})
const CoreAnalyticsLoisUsageRoute = CoreAnalyticsLoisUsageRouteImport.update({
  id: '/analytics/lois-usage',
  path: '/analytics/lois-usage',
  getParentRoute: () => CoreRoute,
})
const CoreAnalyticsProjectDataRoute =
  CoreAnalyticsProjectDataRouteImport.update({
    id: '/analytics/project-data',
    path: '/analytics/project-data',
    getParentRoute: () => CoreRoute,
  })
const CoreAnalyticsTasksRoute = CoreAnalyticsTasksRouteImport.update({
  id: '/analytics/tasks',
  path: '/analytics/tasks',
  getParentRoute: () => CoreRoute,
})
const CoreAnalyticsTimeEntryRoute = CoreAnalyticsTimeEntryRouteImport.update({
  id: '/analytics/time-entry',
  path: '/analytics/time-entry',
  getParentRoute: () => CoreRoute,
})
const CoreAnalyticsUserAuditRoute = CoreAnalyticsUserAuditRouteImport.update({
  id: '/analytics/user-audit',
  path: '/analytics/user-audit',
  getParentRoute: () => CoreRoute,
})
const CoreBoardBoardIdRoute = CoreBoardBoardIdRouteImport.update({
  id: '/board/$boardId',
  path: '/board/$boardId',
  getParentRoute: () => CoreRoute,
})
const CoreKanbanIndexRoute = CoreKanbanIndexRouteImport.update({
  id: '/kanban/',
  path: '/kanban/',
  getParentRoute: () => CoreRoute,
})
const CoreKanbanProjectIdRoute = CoreKanbanProjectIdRouteImport.update({
  id: '/kanban/$projectId',
  path: '/kanban/$projectId',
  getParentRoute: () => CoreRoute,
})
const CoreLeadDocketIndexRoute = CoreLeadDocketIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CoreLeadDocketRoute,
})
const CoreLeadDocketAnalyticsRoute = CoreLeadDocketAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => CoreLeadDocketRoute,
})
const CoreLeadDocketAutomationsRoute =
  CoreLeadDocketAutomationsRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => CoreLeadDocketRoute,
  })
const CoreLeadDocketKanbanRoute = CoreLeadDocketKanbanRouteImport.update({
  id: '/kanban',
  path: '/kanban',
  getParentRoute: () => CoreLeadDocketRoute,
})
const CoreSupportRequestsIndexRoute =
  CoreSupportRequestsIndexRouteImport.update({
    id: '/support-requests/',
    path: '/support-requests/',
    getParentRoute: () => CoreRoute,
  })
const CoreSupportRequestsCreateRoute =
  CoreSupportRequestsCreateRouteImport.update({
    id: '/support-requests/create',
    path: '/support-requests/create',
    getParentRoute: () => CoreRoute,
  })

const CoreLeadDocketRouteChildren = {
  CoreLeadDocketAnalyticsRoute: CoreLeadDocketAnalyticsRoute,
  CoreLeadDocketAutomationsRoute: CoreLeadDocketAutomationsRoute,
  CoreLeadDocketKanbanRoute: CoreLeadDocketKanbanRoute,
  CoreLeadDocketIndexRoute: CoreLeadDocketIndexRoute,
}

const CoreLeadDocketRouteWithChildren = CoreLeadDocketRoute._addFileChildren(
  CoreLeadDocketRouteChildren,
)

const CoreRouteChildren = {
  CoreAutomationsRoute: CoreAutomationsRoute,
  CoreLeadDocketRoute: CoreLeadDocketRouteWithChildren,
  CoreOrganizationManagerRoute: CoreOrganizationManagerRoute,
  CoreSettingsRoute: CoreSettingsRoute,
  CoreIndexRoute: CoreIndexRoute,
  CoreAnalyticsAiUsageRoute: CoreAnalyticsAiUsageRoute,
  CoreAnalyticsCalendarRoute: CoreAnalyticsCalendarRoute,
  CoreAnalyticsDeadlinesAndEventsRoute: CoreAnalyticsDeadlinesAndEventsRoute,
  CoreAnalyticsInvoiceRoute: CoreAnalyticsInvoiceRoute,
  CoreAnalyticsLoisUsageRoute: CoreAnalyticsLoisUsageRoute,
  CoreAnalyticsProjectDataRoute: CoreAnalyticsProjectDataRoute,
  CoreAnalyticsTasksRoute: CoreAnalyticsTasksRoute,
  CoreAnalyticsTimeEntryRoute: CoreAnalyticsTimeEntryRoute,
  CoreAnalyticsUserAuditRoute: CoreAnalyticsUserAuditRoute,
  CoreBoardBoardIdRoute: CoreBoardBoardIdRoute,
  CoreKanbanProjectIdRoute: CoreKanbanProjectIdRoute,
  CoreSupportRequestsCreateRoute: CoreSupportRequestsCreateRoute,
  CoreAnalyticsIndexRoute: CoreAnalyticsIndexRoute,
  CoreKanbanIndexRoute: CoreKanbanIndexRoute,
  CoreSupportRequestsIndexRoute: CoreSupportRequestsIndexRoute,
}

const CoreRouteWithChildren = CoreRoute._addFileChildren(CoreRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,
  CoreRoute: CoreRouteWithChildren,
  ErrorRoute: ErrorRoute,
  LegalwarePowerUserRoute: LegalwarePowerUserRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthIndexRoute: AuthIndexRoute,
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)
